<template>
  <v-container fill-height>
    <v-row no-gutters class="white">
      <v-col cols="6" class="px-1">
<v-row no-gutters  >
            <v-col cols="12">
              <v-list-item v-if="status!=='New'&&status!=='Invited'">
                <v-list-item-content>
                  <v-list-item-subtitle class="subtitle">
                    Status:
                  </v-list-item-subtitle>
                  <v-list-item-title class="headline font-weight-bold">
                    {{status}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="pt-2" v-if="isHefe">
                  <v-btn color="red" class="px-4" @click="$emit('end-contract')" v-if="isHefe"><span class="white--text">{{ $language.jobDetails['End Contract'] }}End Contract</span></v-btn>
                </v-list-item-action>
                <v-list-item-action class="pt-2" v-else>
                  <v-btn color="red" class="px-4" @click="$emit('withdraw')" v-if="!isHefe"><span class="white--text">{{ $language.jobDetails['Withdraw'] }}</span></v-btn>
                </v-list-item-action>
              </v-list-item>
              <div>
                <v-list-item dense @click="$router.replace('/stripe-registration')" v-if="!hasStripe||!payoutsEnabled" class="px-0">
                  <v-list-item-avatar tile class="px-0">
                    <v-icon color="error">info_outline</v-icon>

                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row no-gutters justify="center">

                      <span class="caption error--text" v-if="hasStripe&&!payoutsEnabled">{{$language.jobDetails['Pending Stripe']}}</span>
                      <span class="caption error--text" v-if="!hasStripe&&!payoutsEnabled">{{$language.jobDetails['Stripe Required']}}</span>
                    </v-row>

                  </v-list-item-content>
                </v-list-item>
                <v-row v-if="(status ==='New' || status ==='Invited')&&hasStripe&&payoutsEnabled" justify="center">
                  <v-col cols="12" align="center">
                    <v-btn color="primary" large block @click="$emit('apply')" class="font-weight-bold" v-if="hasStripe&&payoutsEnabled">{{$language.jobDetails['Apply for this job!']}}</v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="12" class="my-1">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12">
              <v-list-item>
                <v-list-item-avatar tile size="48" v-if="(job.public || {}).category || false">
                  <img :src="require(`@/assets/${job.public.category}.svg`)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="display-1">
                    {{job.public.title}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" class="my-1">
              <v-divider></v-divider>
            </v-col>

            <v-row no-gutters>
              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle class="subtitle">
                      Start Date:
                    </v-list-item-subtitle>
                    <v-list-item-title :class="'text-h6 font-weight-bold'">
                      {{job.public.startDate|formatShortDate}}
                    </v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
              </v-col>
              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle class="subtitle">
                      Contract End Date:
                    </v-list-item-subtitle>
                    <v-list-item-title :class="'text-h6 font-weight-bold'">
                      {{job.public.contractEndDate|formatShortDate}}
                    </v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle class="subtitle">
                      Start Time:
                    </v-list-item-subtitle>
                    <v-list-item-title :class="'text-h6 font-weight-bold'">
                      {{(job.public.startTime||{}).h}}:{{(job.public.startTime||{}).mm}} {{(job.public.startTime||{}).A}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="6" class="pl-0">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle class="subtitle">
                      Duration:
                    </v-list-item-subtitle>
                    <v-list-item-title :class="'text-h6 font-weight-bold'">
                      {{job.public.hours}} {{job.public.hours|formatHour}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-col cols="12" v-if="job.public.repeat">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle class="subtitle">
                    Repeating Job:
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-item-group v-if="(job.public.occ||{}).type===$language.addJob['Weeks']" v-model="(job.public||{}).dayToggle" multiple class="pt-2 px-4 pb-4 d-flex justify-space-around">
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">S</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">M</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">T</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">W</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">T</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" :color="active?'primary':''">F</v-chip>
                </v-item>
                <v-item v-slot:default="{ active, toggle }">
                  <v-chip rounded :class="$vuetify.breakpoint.xs?'px-4':'px-4'" @:color="active?'primary':''">S</v-chip>
                </v-item>
              </v-item-group>
              <v-list-item>
                <v-list-item-content>
                  <span class="subtitle">Repeats: {{job.public.scheduleText}}</span>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" class="my-1" v-if="!isHefe">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" class=" py-4 d-flex justify-space-around" v-if="!isHefe">
              <v-btn fab size="48" outlined>
                <v-icon>directions</v-icon>
              </v-btn>
              <v-btn fab size="48" outlined>
                <v-icon>phone</v-icon>
              </v-btn>
              <v-btn fab size="48" outlined @click="openChat">
                <v-icon>chat</v-icon>
              </v-btn>
              <v-btn fab size="48" outlined @click="openTime">
                <v-icon>mdi-play</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12" class="my-1">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" class="my-2">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle class="subtitle">
                    Job Description:
                  </v-list-item-subtitle>
                  <span>{{job.public.jobDesc}}</span>
                </v-list-item-content>
                <v-list-item-action>
                </v-list-item-action>
              </v-list-item>
            </v-col>

            <v-col cols="12" class="my-1" v-if="!isHefe">
              <v-divider></v-divider>
            </v-col>

            <v-col cols="12" class="py-2" v-if="!isHefe">
              <v-list-item>
                <v-list-item-avatar size="48">
                  <v-img :src="job.public.hefeAvatar">
                  </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    {{job.public.hefeName}}
                  </v-list-item-title>
                  <v-list-item-subtitle class="subtitle">
                    <v-row class="pl-2">
                      <v-rating v-model="job.public.hefeRating" small dense half-increments color="primary" background-color="primary" readonly></v-rating>
                      <span class=" caption ml-2">
                        ({{ job.public.hefeRating }})
                      </span>
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                </v-list-item-action>
              </v-list-item>
            </v-col>
            <v-col cols="12" class="my-1">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" v-if="job.public.pictures&&isHefe">
              <v-list-item>
                <v-list-item-content>
                  <v-carousel cycle height="300">
                    <template v-for="(item,index) in job.public.pictures">
                      <v-carousel-item :key="index">
                        <v-sheet height="100%" tile>
                          <v-row class="fill-height" align="center" justify="center">
                            <v-img :src="item.url" cover height="300"></v-img>
                          </v-row>
                        </v-sheet>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
      </v-col>
      <v-col cols="6" class="px-1">
  <v-row no-gutters  >
            <v-col cols="11">
              <v-list-item v-if="status!=='Applied'&&status!=='New'">
                <v-list-item-content>
                  <v-list-item-subtitle class="subtitle">
                    Work Status:
                  </v-list-item-subtitle>
                  <v-list-item-title class="headline font-weight-bold">
                    <span class="font-weight-bold error--text" v-if="!(applicant||{}).clockedIn&&!(applicant.clockLog||false)">Shift Not Started</span>
                    <span class="font-weight-bold success--text" v-if="(applicant||{}).clockedIn">Clocked In</span>
                    <span class="font-weight-bold error--text" v-if="!(applicant||{}).clockedIn&&(applicant.clockLog||false)">Clocked Out</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{((job.applicants||{})[currentUser.uid]||{}).clockedIn}}
                </v-list-item-action>
              </v-list-item>
            </v-col>

            <v-col cols="12" class="my-1" v-if="status!=='Applied'&&status!=='New'">
              <v-divider></v-divider>
            </v-col>

            <v-container>
              <v-row>
                <v-col cols="12">
              <v-list-item>
                <v-list-item-content>
                  <v-carousel cycle height="240" v-if=" job.public.pictures">
                    <template v-for="(item,index) in job.public.pictures">
                      <v-carousel-item :key="index">
                        <v-sheet height="100%" tile>
                          <v-row class="fill-height" align="center" justify="center">
                            <v-img :src="item.url" cover height="300"></v-img>
                          </v-row>
                        </v-sheet>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                </v-list-item-content>
              </v-list-item>
            </v-col>
              </v-row>
            </v-container>

            <v-list-item>
              <v-list-item-content>
                <v-row :key="mapIndex" v-if="(job.public.location || []).length !== 0" align="center" justify="center">
                  <v-col cols="12">
                    <gmap-map :key="mapIndex" :center="{lat: job.public.location[0], lng: job.public.location[1]}" :zoom="12" :style="`height: ${
                $vuetify.breakpoint.xs ? 150 : $vuetify.breakpoint.sm ? 250 : 200
              }px`">
                      <template v-if="status === 'New' || status === 'Applied'">
                        <gmap-circle :center="{lat: job.public.location[0], lng: job.public.location[1]}" @click="center = {lat: job.public.location[0], lng: job.public.location[1]}" :radius="1500" :visible="false" :options="{fillColor: 'blue', fillOpacity: 0.2}" />

                      </template>
                      <gmap-marker v-if="
                  isHefe ||
                  status === 'Hired' ||
                  status === 'Completed' ||
                  status === 'Paid' ||
                  status === 'Started' ||
                  status === 'Pending Payment' ||
                  status === 'Invited'
                " :position="{lat: job.public.location[0], lng: job.public.location[1]}" @click="center = {lat: job.public.location[0], lng: job.public.location[1]}" />
                    </gmap-map>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
export default {
  props: ['job', 'applicant'],
  components: {
  },
  data () {
    return {
      sub: ''
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser'])

  },
  methods: {},
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
